import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import * as R from "ramda";

class InventoryPreviewQR extends Component {
    render() {
        const {PDF, visible, onPreviewQr, onStateChange} = this.props;
        return (
            <SimpleModal
                title="Preview Print QR"
                visible={visible}
                onClickClose={onPreviewQr}
                styles={{
                    width: "100%",
                }}
                content={
                    <>
                        {!R.isNil(PDF) && (
                            <iframe
                                src={PDF}
                                style={{border: "none", width: "100%", minHeight: "100vh"}}
                            ></iframe>
                        )}
                        <input
                            type="file"
                            accept=".pdf"
                            onChange={(e) => {
                                const file = e.target.files[0];
                                if (file && file.type === "application/pdf") {
                                    const fileReader = new FileReader();
                                    fileReader.onload = () => {
                                        onStateChange({
                                            PDF: fileReader.result,
                                        });
                                    };

                                    fileReader.readAsDataURL(file);
                                }
                            }}
                        />
                    </>
                }
            />
        );
    }
}

export default InventoryPreviewQR;